<template>
  <div ref="list" class="flex flex-col">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { type Nullable } from "@pasta/box-v2";
import Sortable, { type SortableEvent } from "sortablejs";
import { onMounted, onUnmounted, ref } from "vue";

interface Props {
  groupName: string;
  dataIdAttr: string;
  handle?: string;
}
const props = defineProps<Props>();
const emit = defineEmits<{
  (e: "drop", event: SortableEvent, ids: number[]): void;
  (e: "choose", event: SortableEvent): void;
  (e: "unChoose", event: SortableEvent): void;
}>();

const list = ref<HTMLUListElement>();
let sortable: Nullable<Sortable>;
onMounted(() => {
  const el = list.value!;
  sortable = Sortable.create(el, {
    direction: "vertical",
    filter: ".not-draggable",
    preventOnFilter: false,
    group: {
      name: props.groupName,
      pull: [props.groupName],
      put: [props.groupName],
    },
    onMove: event => {
      return event.related.className.indexOf("not-draggable-over") === -1;
    },
    dataIdAttr: props.dataIdAttr,
    onAdd: emitDrop,
    onUpdate: emitDrop,
    onChoose: onChoose,
    onUnchoose: onUnchoose,
    handle: props.handle,
  });
});
onUnmounted(() => {
  if (sortable) sortable.destroy();
});

function getIds() {
  return (sortable?.toArray() || []).map(str => parseInt(str));
}

function emitDrop(event: SortableEvent) {
  const ids = getIds();
  // Sometimes sortablejs leaves a ghost div which needs to be cleaned up
  if (event.type === "add") event.item.remove();
  emit("drop", event, ids);
}

function onChoose(event: SortableEvent) {
  emit("choose", event);
}
function onUnchoose(event: SortableEvent) {
  emit("unChoose", event);
}
</script>
